import { DatePipe } from '@angular/common';
import { DateFormatOptions, DefaultDateTransformer, Locale } from '@ngneat/transloco-locale';

export class DateTransformer extends DefaultDateTransformer {
  override transform(date: Date, locale: Locale, options: DateFormatOptions): string {
    // Special Yatta format for english dates
    if (locale === 'en-US' && options.dateStyle && options.dateStyle !== 'full') {
      const format: string = options.dateStyle === 'long' ? 'd MMMM yyyy' : 'd MMM yyyy';
      const formatedDate = new DatePipe(locale).transform(date, format) ?? '';
      const superTransformation = super.transform(date, locale, options);

      return formatedDate + superTransformation.substring(superTransformation.indexOf(date.getFullYear().toString()) + 4);
    }

    // Otherwise, use the default
    return super.transform(date, locale, options);
  }
}
